import { useUsageLimits } from "@/hooks/pricing/useUsageLimits";

export const UsageText = () => {
  const { remainingUsage } = useUsageLimits();

  return (
    <div className="flex items-center gap-1 text-secondary-n-50 m-auto mb-2 flex-col">
      {remainingUsage.dailyPromptsLeft !== undefined && (
        <div>{`${remainingUsage.dailyPromptsLeft} daily prompt(s) left`}</div>
      )}
      {remainingUsage.monthlyPromptsLeft !== undefined && (
        <div>{`${
          remainingUsage.monthlyPromptsLeft === Infinity
            ? "Unlimited"
            : remainingUsage.monthlyPromptsLeft
        } monthly prompt(s) left`}</div>
      )}
      {remainingUsage.extraPromptsInPackages !== undefined && (
        <div>{`${remainingUsage.extraPromptsInPackages} extra prompt(s) left`}</div>
      )}
      {remainingUsage.tokensLeft !== undefined && (
        <div>{`${
          remainingUsage.tokensLeft === Infinity
            ? "Unlimited"
            : remainingUsage.tokensLeftDisplay
        } tokens left`}</div>
      )}
    </div>
  );
};
